import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58827ccf"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]

import { computed, PropType, toRefs } from 'vue';

import MemberBadge from '@/components/MemberBadge.vue';
import { canViewMemberDetails } from '@/helpers/permission';
import { Member, MemberRole } from '@/Member/member.entity';
import { useMemberModalsStore } from '@/stores/member-modals.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberAvatar',
  props: {
    member: {
        type: Object as PropType<Member>,
        required: true,
    },
    disableRoleExpansion: {
        type: Boolean,
        default: false,
    },
    disableClickEvents: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;



const { member, disableRoleExpansion, disableClickEvents } = toRefs(props);

const memberModalsStore = useMemberModalsStore();

const enabledClickEvents = computed(() => !disableClickEvents.value && canViewMemberDetails(member.value));

function openDetails(event: MouseEvent) {
    if (!enabledClickEvents.value) {
        return;
    }
    event.stopPropagation();
    memberModalsStore.openMemberDetails(member.value);
}

const initials = computed(
    () =>
        `${member.value.firstName?.substring(0, 1)?.toUpperCase()}${member.value.lastName
            ?.substring(0, 1)
            ?.toUpperCase()}`,
);

const avatarColor = computed(() => {
    const fullName = member.value.firstName + ' ' + member.value.lastName;

    const colors = [
        '#17d576',
        '#009fd4',
        '#b381b3',
        '#e3bc00',
        '#e98306',
        '#dc2a2a',
        '#088f8f',
        '#5c80c3',
        '#00a36c',
        '#e49e57',
        '#503521',
        '#36454f',
        '#ff7f50',
        '#de3163',
        '#a95c68',
        '#f4d03f',
        '#8e44ad',
    ];

    const hash = fullName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

    const colorIndex = hash % colors.length;
    return colors[colorIndex];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["member-avatar-wrapper", { 'member-avatar-wrapper--clickable': enabledClickEvents.value }]),
    onClick: openDetails
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["member-avatar", { disabled: !_unref(member).isEnabled }]),
      style: _normalizeStyle({ backgroundColor: avatarColor.value }),
      title: _unref(member).firstName + ' ' + _unref(member).lastName
    }, _toDisplayString(initials.value), 15, _hoisted_1),
    (_unref(member).role && _unref(member).role !== _unref(MemberRole).USER)
      ? (_openBlock(), _createBlock(MemberBadge, {
          key: 0,
          role: _unref(member).role,
          "disable-role-expansion": _unref(disableRoleExpansion)
        }, null, 8, ["role", "disable-role-expansion"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})